import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class Text extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
        handleMouseUp: PropTypes.func,
    };

    createMarkup = () => {
        const { content } = this.props;

        return { __html: content };
    };

    render() {
        const { handleMouseUp } = this.props;

        return <div className={styles.text} dangerouslySetInnerHTML={this.createMarkup()} onMouseUp={handleMouseUp} />;
    }
}

export default Text;
